import * as React from 'react';
import { cn } from '@shared';

type TooltipChildProps = React.HTMLAttributes<HTMLElement> & {
  'data-tooltip'?: string;
};

interface TooltipProps {
  children: React.ReactElement<TooltipChildProps>;
  content: string;
}

/**
 * Small, dependency-free tooltip primitive for controls and interactive cards.
 *
 * The native title is kept as a fallback for touch devices and the visually
 * hidden description makes the same copy available to screen readers.
 */
export function Tooltip({ children, content }: TooltipProps) {
  const tooltipId = React.useId();
  const describedBy = [children.props['aria-describedby'], tooltipId]
    .filter(Boolean)
    .join(' ');

  return React.cloneElement(children, {
    title: content,
    'aria-describedby': describedBy,
    'data-tooltip': content,
    className: cn(children.props.className, 'daysheetly-tooltip'),
    children: (
      <>
        {children.props.children}
        <span id={tooltipId} role="tooltip" className="sr-only">
          {content}
        </span>
      </>
    ),
  });
}
